import React from "react";
import { Route, Routes } from "react-router-dom";

import HomePage from "./pages/HomePage";
import CompanyPage from "./pages/CompanyPage";
import EquipmentPage from "./pages/EquipmentPage";
import ContactsPage from "./pages/ContactsPage";

// import ProtectedRoute from "./routes/ProtectedRoute";

function App() {
  return (
    <Routes>
      {/* ЛЕНДИНГ */}
      <Route path="/" element={ <HomePage />} />
      <Route path="/company/" element={ <CompanyPage />} />
      <Route path="/equipment/" element={ <EquipmentPage />} />
      <Route path="/contacts/" element={ <ContactsPage />} />
    </Routes>
  );
}

export default App;
